import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { actions, track } from 'react-redux-form'
import PropTypes from 'prop-types'
import { addError, addMessage } from 'actions'
import PublicInterviewComponent from 'interview/components/public-interview'
import { mapLanguageToComponentProps } from 'interview/i18n'
import FetchWithSpinner from 'components/fetch-with-spinner'
import { fetchJobOpening, startInterview } from 'interview/actions/job-opening'
import * as analytics from 'analytics/performance'
import {
  getCandidateInfoForAmplitude,
  getCompanyAndInterviewInfoForAmplitude,
} from 'selectors'

const propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    query: PropTypes.shape({
      email: PropTypes.string,
    }),
    pathname: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func,
  i18n: PropTypes.shape({}).isRequired,
  interview: PropTypes.shape({
    _id: PropTypes.string,
    language: PropTypes.string,
    publicUuid: PropTypes.string,
    questions: PropTypes.arrayOf(PropTypes.shape({})),
    formSetup: PropTypes.shape({}),
    company: PropTypes.shape({
      branding: PropTypes.shape({}),
      privacyPolicy: PropTypes.string,
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
    endTime: PropTypes.string,
  }).isRequired,
  candidate: PropTypes.shape({}).isRequired,
  params: PropTypes.shape({}).isRequired,
}

const defaultProps = {
  dispatch: undefined,
}

const mapStateToProps = state => ({
  candidate: state.candidate,
  interview: state.interview.jobOpening,
})

export class PublicInterview extends Component {
  constructor(props) {
    super(props)

    let { search } = props.location
    if (search[0] === '?') {
      search = search.substring(1)
    }

    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    const { location, dispatch } = this.props
    const {
      query: { email },
    } = location
    dispatch(actions.change('candidate.email', email))
  }

  onChange(model, value) {
    const {
      dispatch,
      candidate: { additionalFieldResponses },
    } = this.props
    if (model === 'additionalFieldResponse') {
      if (additionalFieldResponses.find(f => f.fieldId === value.fieldId)) {
        dispatch(
          actions.change(
            track('candidate.additionalFieldResponses', {
              fieldId: value.fieldId,
            }),
            value
          )
        )
      } else {
        dispatch(actions.push('candidate.additionalFieldResponses', value))
      }
    } else {
      dispatch(actions.change(model, value))
    }
  }

  onSubmit() {
    const { dispatch, candidate, interview, i18n } = this.props
    const { publicUuid } = interview
    const data = { ...candidate }
    const companyAndInterviewInfo =
      getCompanyAndInterviewInfoForAmplitude(interview)
    const candidateInfo = getCandidateInfoForAmplitude(candidate)

    dispatch(startInterview({ uuid: publicUuid, candidate: data }))
      .then(candidate => {
        analytics.onClickEvent({
          locationId: 'publicInterviewPage',
          id: 'continueInterviewButton',
          properties: {
            ...candidateInfo,
            ...companyAndInterviewInfo,
          },
        })
        browserHistory.push(`/enter/${candidate.uuid}`)
      })
      .catch(err => {
        if (err.response && err.response.status === 409) {
          dispatch(
            addMessage({
              style: 'warning',
              text: i18n.interview.duplicateError,
            })
          )
        } else {
          dispatch(addError(err))
          throw err
        }
      })
  }

  render() {
    const { candidate, params, interview, location } = this.props
    const {
      query: { email },
    } = location

    const companyAndInterviewInfo =
      getCompanyAndInterviewInfoForAmplitude(interview)
    const candidateInfo = getCandidateInfoForAmplitude(candidate)

    const videoEventProps = {
      ...candidateInfo,
      ...companyAndInterviewInfo,
    }

    return (
      <FetchWithSpinner action={() => fetchJobOpening(params, true)}>
        <PublicInterviewComponent
          candidate={candidate}
          interview={interview}
          onSubmit={this.onSubmit}
          onChange={this.onChange}
          model="candidate"
          disableEmail={!!email}
          videoEventProps={videoEventProps}
        />
      </FetchWithSpinner>
    )
  }
}

PublicInterview.propTypes = propTypes
PublicInterview.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps(mapStateToProps))(
  PublicInterview
)
